import i18n from '../i18n';

function parseTimeToMinutes(value) {
  if (!value || typeof value !== 'string') return null;
  const [h, m] = value.split(':').map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return null;
  return h * 60 + m;
}

function isWithinDailyWindow(now, windowStartTime, windowEndTime) {
  if (!windowStartTime || !windowEndTime) return true;

  const startMins = parseTimeToMinutes(windowStartTime);
  const endMins = parseTimeToMinutes(windowEndTime);
  if (startMins == null || endMins == null) return true;

  const currentMins = now.getHours() * 60 + now.getMinutes();
  if (endMins > startMins) {
    return currentMins >= startMins && currentMins <= endMins;
  }
  return currentMins >= startMins || currentMins <= endMins;
}

export function isModalNotificationActive(notification, now = new Date()) {
  if (!notification || notification.type !== 'modal') return true;

  const startAt = notification.showStartAt || notification.show_start_at;
  if (!startAt) return true;

  const start = new Date(startAt);
  if (Number.isNaN(start.getTime()) || now < start) return false;

  const endAt = notification.showEndAt || notification.show_end_at;
  if (endAt) {
    const end = new Date(endAt);
    if (!Number.isNaN(end.getTime()) && now > end) return false;
  }

  const windowStart = notification.windowStartTime || notification.window_start_time;
  const windowEnd = notification.windowEndTime || notification.window_end_time;
  return isWithinDailyWindow(now, windowStart, windowEnd);
}

export function formatScheduleSummary(item) {
  if (!item?.showStartAt) return i18n.t('admin:notificationSchedule.immediatelyShown');

  const start = formatDateTime(item.showStartAt);
  const end = item.showEndAt ? formatDateTime(item.showEndAt) : '—';
  const window = item.windowStartTime && item.windowEndTime
    ? `${item.windowStartTime} – ${item.windowEndTime}`
    : null;
  const duration = (item.durationDays || item.durationHours)
    ? i18n.t('admin:notificationSchedule.durationFormat', { days: item.durationDays || 0, hours: item.durationHours || 0 })
    : null;

  const parts = [`${start} → ${end}`];
  if (window) parts.push(i18n.t('admin:notificationSchedule.windowLabel', { window }));
  if (duration) parts.push(i18n.t('admin:notificationSchedule.durationLabel', { duration }));
  return parts.join(' · ');
}

function formatDateTime(iso) {
  const d = new Date(iso);
  return d.toLocaleString(i18n.language, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getDefaultScheduleDate() {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
}
